import React from 'react';
import { View } from 'react-native';

import { SectionHeader } from '@vfgroup-oneplatform/foundation/Components';
import PropTypes from 'prop-types';

import style from './SectionStyle';

const Section = ({ title, theme, component: Component }) => {
  return (
    <View>
      <SectionHeader style={style.sectionHeaderStyle} theme={theme} title={title} />
      {Component}
    </View>
  );
};

Section.propTypes = {
  title: PropTypes.string,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  component: PropTypes.node,
};

export default Section;
